export const PAGE_NAME_VALIDATION_MESSAGE =
  'Sorry, you can’t use ! @ # $ % ^ & * ‘ / ( ) , ? “ : ; { } | < >.'
